export const Marquee = ({ items, reverse = false, className = "" }) => (
    <div className={`overflow-hidden border-y border-[#0A0F1D]/10 py-5 ${className}`} aria-hidden="true">
        <div className={`marquee-track flex w-max ${reverse ? "reverse" : ""}`}>
            {[0, 1].map((dup) => (
                <div key={dup} className="flex shrink-0 items-center">
                    {items.map((item, i) => (
                        <span
                            key={`${dup}-${i}`}
                            className="flex items-center gap-8 pr-8 font-display text-sm sm:text-base font-bold uppercase tracking-[0.3em] text-slate-500"
                        >
                            {item}
                            <span className="inline-block h-1.5 w-1.5 rotate-45 bg-[#0066FF]" />
                        </span>
                    ))}
                </div>
            ))}
        </div>
    </div>
);
